import React from 'react';
import ProfilePic from '@images/profilePic.png';
import { useAuth } from "@context";
import { HeartRedIcon } from '@util/svgicon';
import * as actionTypes from "@redux/actionTypes";
import { useSelector, useDispatch } from "react-redux";
import { useRouter } from 'next/router';

const LeftSection = () => {
    const router = useRouter();
    const dispatch = useDispatch();
    const { userDetails } = useAuth();
    const Bucket_url = process.env.NEXT_PUBLIC_DELIEVERY_CONTENT_URL
    const ProfilePicture = userDetails?.avatar_url ? `${Bucket_url}${userDetails?.avatar_url}` : ProfilePic;

    const user = useSelector((state) => state.setUserDetails.user);
    const fullLicenceMetaData = useSelector((state) => state.minting.fullLicenceMetaData);
    const coinInputNumberDefault = useSelector((state) => state.coinName.coinInputNumberDefault);

    const buyTcHandler = () => {
        dispatch({
            type: actionTypes.BUY_TC,
            payload: true,
        });
        dispatch({
            type: actionTypes.COIN_BALANCE_NUMBER,
            payload: coinInputNumberDefault,
        });
    };

    const buyLpHandler = () => {
        router.push('/buy-gamepass');
    }

    return (
        <div className='h-full flex gap-[10px] p-[32px] flex-col justify-between items-center'>
            <div className='flex flex-col items-start gap-[16px]'>
                <p className='text-[#FAFAFA] text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px] opacity-50'>It's you!</p>
                <img
                    src={ProfilePicture}
                    alt="UserProfile"
                    style={{ borderRadius: '50%', width: '96px', height: '96px' }}
                />
                <div className='flex flex-col justify-center items-start gap-[8px]'>
                    <p className='text-[#FAFAFA] break-all text-[32px] not-italic font-semibold leading-[32px] tracking-[-1.92px]'>{user?.username}</p>
                    <div className='flex justify-center items-center gap-[8px]'>
                        <div className='flex items-center gap-[2px]'>
                            <HeartRedIcon />
                            <p className='text-[#FAFAFA] text-[20px] not-italic font-semibold leading-[24px] tracking-[-1.2px]'>: {fullLicenceMetaData?.life_point} LP</p>
                        </div>
                        <p className='text-[#FAFAFA] text-[20px] not-italic font-semibold leading-[24px] tracking-[-1.2px]'>XP: {user?.experience_points}</p>
                    </div>
                </div>
                <p className='text-[#FAFAFA] text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>
                    Welcome to your profile! View your transactions, recent stats, and more for the past week, month, and beyond!
                </p>
            </div>
            <div className='flex flex-col items-start gap-[16px] self-stretch'>
                {/* <button className='flex w-full h-[56px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[32px] bg-[#25BD66]' onClick={buyLpHandler}>
                    <p className='text-[#FAFAFA] text-[20px] not-italic font-semibold leading-[20px] tracking-[-0.8px]'>
                        Purchase More LP
                    </p>
                </button>
                <button className='flex w-full h-[56px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[32px] bg-[#25BD66]' onClick={buyTcHandler}>
                    <p className='text-[#FAFAFA] text-[20px] not-italic font-semibold leading-[20px] tracking-[-0.8px]'>
                        Purchase TC
                    </p>
                </button> */}
                <button className='flex w-full h-[56px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[32px] bg-[#000]' onClick={() => { window.open(`https://shop.frodobots.com/`) }}>
                    <p className='text-[#FAFAFA] text-[20px] not-italic font-semibold leading-[20px] tracking-[-0.8px]'>
                        Buy an EarthRover
                    </p>
                </button>
            </div>
        </div>
    )
}

export default LeftSection